import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module')
      .then(m => m.AuthModule),
  },
  {
    path: 'feedback',
    loadChildren: () => import('./feedback/feedback.module')
      .then(m => m.FeedbackModule),
  },
  {
    path: 'administrator',
    loadChildren: () => import('./administrator/administrator.module')
      .then(m => m.AdministratorModule),
  },
  {
    path: 'restaurant-manager',
    loadChildren: () => import('./restaurant-manager/restaurant-manager.module')
      .then(m => m.RestaurantManagerModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
